import { computed, makeObservable, observable } from "mobx"

import { BaseModel } from "./base.model"

export class SubscriptionModel extends BaseModel {
  // @ts-ignore
  constructor(params) {
    super(params)
    makeObservable(this)
  }

  @observable loading: boolean = false

  @computed get showPopUp() {
    const { journalPopUp } =
      this.Models.GlobalModel.featureToggles.emailSubscription || {}

    return journalPopUp
  }

  @computed get popUpDelay() {
    const { journalPopUpDelay } =
      this.Models.GlobalModel.featureToggles.emailSubscription || {}

    return journalPopUpDelay
  }

  hydrate = (data: unknown) => {
    // @ts-ignore
    this.applyData({ loading: data?.loading })
  }

  serialize = () => {
    return {
      loading: this.loading,
    }
  }

  sendConfirmation = async (email: string) => {
    this.applyData({ loading: true })

    try {
      await this.Providers.SubscriptionProvider.sendConfirmation({
        email,
        lang: this.Models.GlobalModel.lang,
      })
      this.applyData({ loading: false })
      /* eslint-disable @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      if (error.response.status !== 409) {
        throw error
      }
    } finally {
      this.applyData({ loading: false })
    }
  }
}
